"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var asynciterator_union_1 = require("asynciterator-union");
/**
 * A comunica Union Query Operation Actor.
 */


var ActorQueryOperationUnion =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationUnion, _bus_query_operation_);

  function ActorQueryOperationUnion(args) {
    _classCallCheck(this, ActorQueryOperationUnion);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationUnion).call(this, args, 'union'));
  }
  /**
   * Takes the union of the given double array variables.
   * Uniqueness is guaranteed.
   * @param {string[][]} variables Double array of variables to take the union of.
   * @return {string[]} The union of the given variables.
   */


  _createClass(ActorQueryOperationUnion, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var outputs, bindingsStream, metadata, variables;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all([this.mediatorQueryOperation.mediate({
                  operation: pattern.left,
                  context: context
                }), this.mediatorQueryOperation.mediate({
                  operation: pattern.right,
                  context: context
                })]);

              case 2:
                _context2.t0 = bus_query_operation_1.ActorQueryOperation.getSafeBindings;
                outputs = _context2.sent.map(_context2.t0);
                bindingsStream = new asynciterator_union_1.RoundRobinUnionIterator(outputs.map(function (output) {
                  return output.bindingsStream;
                }));
                metadata = outputs[0].metadata && outputs[1].metadata ? function () {
                  return Promise.all([outputs[0].metadata(), outputs[1].metadata()]).then(ActorQueryOperationUnion.unionMetadata);
                } : null;
                variables = ActorQueryOperationUnion.unionVariables(outputs.map(function (output) {
                  return output.variables;
                }));
                return _context2.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  metadata: metadata,
                  variables: variables
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }], [{
    key: "unionVariables",
    value: function unionVariables(variables) {
      return require('lodash.union').apply({}, variables);
    }
    /**
     * Takes the union of the given metadata array.
     * It will ensure that the totalItems metadata value is properly calculated.
     * @param {{[p: string]: any}[]} metadatas Array of metadata.
     * @return {{[p: string]: any}} Union of the metadata.
     */

  }, {
    key: "unionMetadata",
    value: function unionMetadata(metadatas) {
      var totalItems = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = metadatas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var metadata = _step.value;

          if (metadata.totalItems && isFinite(metadata.totalItems)) {
            totalItems += metadata.totalItems;
          } else {
            totalItems = Infinity;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        totalItems: totalItems
      };
    }
  }]);

  return ActorQueryOperationUnion;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationUnion = ActorQueryOperationUnion;